import { useEffect, useState } from 'react';
import axios from 'axios';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { LineChart, Line, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer } from 'recharts';
import { TrendingUp } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const DBGrowthChartWidget = () => {
  const [data, setData] = useState(null);

  useEffect(() => {
    axios
      .get(`${BACKEND_URL}/api/super-admin/db/size-history?months=12`, { withCredentials: true })
      .then(({ data }) => setData(data))
      .catch(() => setData({ series: [], count: 0 }));
  }, []);

  if (!data) return null;

  const chartData = (data.series || []).map((h) => ({
    date: new Date(h.captured_at).toLocaleDateString('pt-PT', { day: '2-digit', month: 'short' }),
    data_MB: +(h.data_size_bytes / 1024 / 1024).toFixed(2),
    indexes_MB: +(h.index_size_bytes / 1024 / 1024).toFixed(2),
  }));

  return (
    <Card data-testid="db-growth-chart-widget" className="border-slate-200">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-slate-900">
          <TrendingUp className="w-5 h-5 text-indigo-600" />
          Crescimento da base de dados (12 meses)
        </CardTitle>
        <CardDescription>
          Evolução do tamanho de dados e índices - snapshots semanais em <code>db_size_history</code>
        </CardDescription>
      </CardHeader>
      <CardContent>
        {chartData.length < 2 ? (
          <p className="text-center py-10 text-slate-500 text-sm">
            Ainda sem histórico suficiente. Ative "Snapshot semanal de tamanho da BD" em Automações.
          </p>
        ) : (
          <ResponsiveContainer width="100%" height={240}>
            <LineChart data={chartData} margin={{ top: 12, right: 12, bottom: 0, left: -8 }}>
              <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" />
              <XAxis dataKey="date" tick={{ fontSize: 11 }} />
              <YAxis tick={{ fontSize: 11 }} unit=" MB" />
              <Tooltip contentStyle={{ fontSize: 12 }} formatter={(v) => `${v} MB`} />
              <Line type="monotone" dataKey="data_MB" name="Dados" stroke="#6366F1" strokeWidth={2} dot={{ r: 3 }} />
              <Line type="monotone" dataKey="indexes_MB" name="Índices" stroke="#10B981" strokeWidth={2} dot={{ r: 3 }} />
            </LineChart>
          </ResponsiveContainer>
        )}
      </CardContent>
    </Card>
  );
};

export default DBGrowthChartWidget;
